import styled from 'styled-components'
import { ResetPasswordFormUnstyled } from './unstyled'

export const ResetPasswordForm = styled(ResetPasswordFormUnstyled)`
  position: relative;
  width: 100%;
  height: 100%;

  form {
    position: absolute;
    width: 100%;
    max-width: 360px;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto;
    transform: translateY(-50%);
  }

  input[type='submit'] {
    margin: 38px 0 0 0;
  }

  .form-inputs {
    margin: 0 0 13px 0;
  }

  h1 {
    font-size: 28px;
    margin: 0 0 40px 0;
  }

  @media screen and (max-device-width: 400px), screen and (max-width: 400px) {
    form {
      position: static;
      transform: none;
      margin-top: 50px;
      text-align: center;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/ResetPassword/index.js